export default __webpack_public_path__ + "static/media/telefonia_top.fc7e125c.jpg";